export default __webpack_public_path__ + "static/media/b49.48bdb8d6.png";